import script from "./Sheelon2View.vue?vue&type=script&setup=true&lang=js"
export * from "./Sheelon2View.vue?vue&type=script&setup=true&lang=js"

import "./Sheelon2View.vue?vue&type=style&index=0&id=4ceced6a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ceced6a"]])

export default __exports__